import { useState } from 'react'

export function CartDrawerTest({ config }) {
  const [localCount, setLocalCount] = useState(Number(config.cartCount || 0))

  return (
    <div className="nova-react-cart-drawer-test alert alert-light border mb-0" data-react-ready="true">
      <div className="d-flex align-items-center justify-content-between gap-3">
        <div>
          <strong>React cart drawer island</strong>
          <div className="small text-muted">
            Panier detecte : {localCount} article{localCount > 1 ? 's' : ''}
          </div>
        </div>

        <button
          className="btn btn-outline-dark btn-sm"
          type="button"
          onClick={() => setLocalCount((count) => count + 1)}
        >
          Test +1
        </button>
      </div>

      {config.cartUrl && (
        <a className="small d-inline-block mt-2" href={config.cartUrl}>
          Ouvrir le panier WooCommerce
        </a>
      )}
    </div>
  )
}
